import styled from 'styled-components';

export const StyledComponent = styled.div`
  flex-basis: 14.28%;
  height: 100%;
  max-height: ${props => props.height};
  border-top: 1px solid #ebecf0;
  border-right: 1px solid #ebecf0;
  background: ${props => (props.shadowed ? '#fff' : props.isToday ? '#e9f0fb' : '#fafafa')};
  box-sizing: border-box;
  display: flex;
  flex-flow: column nowrap;
  user-select: none;

  &:before,
  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1;
    pointer-events: none;
  }
  &:after {
    // background: rgba(180, 212, 238, 0.3);
    opacity: ${props => (props.selected ? '0.9' : '0')};
    transition: opacity .3s ${props => (props.selected ? 'ease-in' : 'ease-out')};
  }
`;

StyledComponent.displayName = 'StyledComponent';

export const CalendarDayHeader = styled.div`
  color: rgba(0, 0, 0, .53);
  flex: 0 0 28px;
  background: #fff;
  border-bottom: 1px solid #f0f1f2;
  justify-content: center;
  flex-flow: row nowrap;
`;
export const CalendarDayHeaderBody = styled.div`
  display: flex;
  height: 100%;
  align-items: center;
`;

export const CalendarDayHeaderNumber = styled.div`
  align-self: flex-end;
  margin: auto 0;
  margin-left: auto;
  opacity: ${props => (props.shadowed ? 0.4 : 0.9)};
`;

export const CalendarDayBody = styled.div`
  width: 100%;
  display: flex;
  box-sizing: border-box;
  flex-flow: column nowrap;
  overflow: ${props => (props.fetching ? 'hidden' : 'auto')};
  height: ${props => props.height}px;
  background: ${props => (props.shadowed ? '#fff' : 'transparent')};
`;
